import React from 'react';
import Invoice from './records/Invoice';
import Order from './records/Order';

const Production = () => {
  const quoteId = 8; //6;//2;//14; // Replace with actual quote ID or state

  return (
    <div className="content-container">
      <h1>Production</h1>
      <p>This is the Production page.</p>

      {/* Render Invoice with a quoteId prop */}
      <Order quoteId={quoteId} showLinePrices={true} />
      <hr></hr>
      <Invoice quoteId={quoteId} />
    </div>
  );
};

export default Production;
